var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-pago'),_vm._v(" "),_c('section-success',{attrs:{"full-name":_vm.fullName}}),_vm._v(" "),(!_vm.isPeru)?_c('section-payment'):_vm._e(),_vm._v(" "),_c('new-footer',{attrs:{"gray":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edf9be6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page-success-inscription.vue
// module id = 705
// module chunks = 2